import { render } from "./BulkProductGrid.vue?vue&type=template&id=6789135c&scoped=true"
import script from "./BulkProductGrid.vue?vue&type=script&lang=js"
export * from "./BulkProductGrid.vue?vue&type=script&lang=js"

import "./BulkProductGrid.vue?vue&type=style&index=0&id=6789135c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6789135c"]])

export default __exports__